// extracted by mini-css-extract-plugin
export default {"show_text":"ShowText_show_text__lCO1n"};